import React from 'react';
import { WixStyleReactMaskingContext } from '../context';
import { render } from '@testing-library/react';
import WixStyleReactMaskingProvider from '../WixStyleReactMaskingProvider';
import { maskingClassNames as maskingClasses } from '../constants';

describe('WixDesignSystemsMaskingContext', () => {
  it('should provide masking classNames trough its context', async () => {
    const { container } = render(
      <WixStyleReactMaskingProvider>
        <WixStyleReactMaskingContext.Consumer>
          {({ maskingClassNames }) => (
            <div
              data-hook="masked-component"
              data-mask={maskingClassNames}
            ></div>
          )}
        </WixStyleReactMaskingContext.Consumer>
      </WixStyleReactMaskingProvider>,
    );

    const rootEl = container.querySelector(`[data-hook="masked-component"]`);

    expect(rootEl?.getAttribute('data-mask')).toBe(maskingClasses);
  });
});
